import { APP_ERROR_TYPE } from './types';
export class AppError extends Error {
    constructor(options = {}) {
        super();
        this.name = 'AppError';
        this.message = options.message || 'Internal';
        this.type = options.type || APP_ERROR_TYPE.INTERNAL;
        this.status = options.status || 500;
        this.details = options.details || {};
        this.timestamp = options.timestamp || new Date().getTime();
    }
    detailsToObject() {
        return {
            name: this.name,
            message: this.message,
            type: this.type,
            status: this.status,
            details: this.details,
            timestamp: this.timestamp,
        };
    }
}
//# sourceMappingURL=AppError.js.map